import { CustomTabs } from '@atbay/cyber-components'
import { useCustomTheme } from '@/core/theme'
import CaseTabCommunication from '@ui/drawer/caseDetails/components/caseTabs/caseTabCommunication/caseTabCommunication'
import CaseTabDetection from '@ui/drawer/caseDetails/components/caseTabs/caseTabDetection/caseTabDetection'
import CaseTabRelatedCases from '@ui/drawer/caseDetails/components/caseTabs/caseTabRelatedCases/caseTabRelatedCases'
import { Wrapper } from '@ui/drawer/caseDetails/components/caseTabs/caseTabs.styles'
import { AccountModule } from '@core/modules/account/account.module'
import { Analytics } from '@core/services/mixpanel'

interface Props {
    caseData: any
    currentTab: 'alerts' | 'incidents'
}

const CaseTabs = ({ caseData, currentTab }: Props) => {
    const theme = useCustomTheme()
    const [selectedTab, setSelectedTab] = useState('detectionDetails')

    useEffect(() => {
        setSelectedTab('detectionDetails')
    }, [caseData])

    const handleTabChange = (tab: string) => {
        setSelectedTab(tab)
        Analytics.event('SEM::mdr_case_drawer_tab_clicked', {
            isMdrActive: AccountModule.store.get().isMdrActive,
            tab,
            currentTab,
        })
    }

    const tabList = [
        {
            key: 'detectionDetails',
            label: 'Detection details',
        },
        {
            key: 'relatedCases',
            label: 'Related cases',
        },
    ]

    return (
        <Wrapper>
            <CustomTabs
                onTabChange={handleTabChange}
                activeKey={selectedTab}
                items={tabList}
                activeStyles={{ color: theme.colors.primary[900] }}
                inactiveStyles={{
                    color: theme.colors.primary[400],
                }}
            />
            {
                {
                    communication: <CaseTabCommunication data={caseData} />,
                    detectionDetails: <CaseTabDetection caseData={caseData} />,
                    relatedCases: (
                        <CaseTabRelatedCases
                            caseData={caseData}
                            currentTab={currentTab}
                        />
                    ),
                }[selectedTab]
            }
        </Wrapper>
    )
}

export default CaseTabs
